<div id="main" class="internal">
  <div id="slot-management" class="section slot-management">
    <div class="content-body">
      <div class="title">
        <h1>{{ "slot_management.title" | translate }}</h1>
      </div>
      <div class="content">
        <div class="search">
          <div class="fieldset">
            <label for="Restaurants">{{
              "slot_management.select_restaurant" | translate
            }}</label>
            <p-select
              [(ngModel)]="selectedRestaurant"
              [options]="Restaurants"
              optionLabel="dropdownLabel"
              [style]="{ width: '100%' }"
              placeholder="{{
                'slot_management.select_restaurant' | translate
              }}"
              (onChange)="ResetForm()"
              [filter]="true"
            />
          </div>
        </div>
        @if(selectedRestaurant) {
        <div class="fieldset">
          <label for="date">{{
            "slot_management.select_date" | translate
          }}</label>
          <p-datepicker
            [(ngModel)]="date"
            [iconDisplay]="'input'"
            [showIcon]="true"
            [minDate]="retentionDate"
            inputId="date"
            [style]="{ width: '100%' }"
            (onSelect)="GetSlots()"
            [firstDayOfWeek]="1"
            selectOtherMonths="true"
          />
        </div>
        @if(date){
        <div class="fieldset">
          <div
            style="
              display: flex;
              justify-content: space-between;
              margin-top: 10px;
            "
          >
            <p-button
              icon="pi pi-angle-double-left"
              severity="secondary"
              (onClick)="prevDate()"
            />
            <p-button
              icon="pi pi-angle-double-right"
              severity="secondary"
              (onClick)="succDate()"
            />
          </div>
        </div>
        }@if(date) { @if(slotLoaded){

        <div class="table slots">
          <div class="ca-card">
            <p-table
              [value]="slots"
              [paginator]="true"
              [rows]="5"
              [tableStyle]="{ width: '100%' }"
              styleClass="p-datatable-sm p-datatable-striped"
            >
              <ng-template pTemplate="header">
                <tr>
                  <th pSortableColumn="slot_start">
                    {{ "slot_management.start_time" | translate }}
                    <p-sortIcon field="slot_start" />
                  </th>
                  <th pSortableColumn="slot_end">
                    {{ "slot_management.end_time" | translate }}
                    <p-sortIcon field="slot_end" />
                  </th>
                  <th pSortableColumn="has_booked_table">
                    {{ "slot_management.has_booked_tables" | translate }}
                    <p-sortIcon field="has_booked_table" />
                  </th>
                  <th pSortableColumn="category">
                    {{ "edit_slot.category" | translate }}
                    <p-sortIcon field="category" />
                  </th>
                  <th style="width: 20%">
                    {{ "slot_management.actions" | translate }}
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-slot>
                <tr>
                  <td>{{ slot.slot_start | date : "HH:mm" : "+0000" }}</td>
                  <td>{{ slot.slot_end | date : "HH:mm" : "+0000" }}</td>
                  <td>
                    {{
                      (slot.has_booked_table === 1 ? "yes" : "no") | translate
                    }}
                  </td>
                  <td>
                    {{ slot.category }}
                  </td>
                  <td>
                    <p-button
                      [text]="true"
                      [pTooltip]="'edit' | translate"
                      tooltipPosition="top"
                      icon="pi pi-pencil"
                      (click)="
                        GoToEdit(slot.id_restaurant_slot, slot.has_booked_table)
                      "
                    />
                    <p-button
                      [text]="true"
                      [pTooltip]="'delete' | translate"
                      tooltipPosition="top"
                      icon="pi pi-trash"
                      [disabled]="slot.has_booked_table == 1"
                      (onClick)="deleteSlot(slot)"
                    />
                    <p-button
                      [text]="true"
                      [pTooltip]="'slot_management.duplicate' | translate"
                      tooltipPosition="top"
                      icon="pi pi-clone"
                      (onClick)="DuplicateSlot(slot)"
                    />
                  </td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage">
                <tr>
                  <td colspan="5">
                    <div class="message">
                      <div class="icon">
                        <img
                          src="../../../assets/images/Info.svg"
                          alt="Info icon"
                        />
                      </div>
                      <div
                        class="text"
                        [innerHTML]="'slot_management.no_slots' | translate"
                      ></div>
                    </div>
                  </td>
                </tr>
              </ng-template>
              <ng-template pTemplate="paginatorright">
                <p-button
                  type="button"
                  label="{{ 'slot_management.duplicate_day' | translate }}"
                  icon="pi pi-clone"
                  styleClass="p-button-text"
                  (onClick)="DuplicateDay()"
                />
              </ng-template>
            </p-table>
          </div>
        </div>
        } } }
        <div class="buttons">
          <button class="costa-button outline" type="button" (click)="Back()">
            {{ "cancel" | translate }}
          </button>
          @if(date && slotLoaded){

          <button class="costa-button" type="button" (click)="GoToAdd()">
            {{ "slot_management.add_slot" | translate }}
          </button>
          }
        </div>
      </div>
    </div>
  </div>
</div>
